<div>
  <div class="mb-6">
    <div class="font-syne text-2xl font-semibold mb-5">
      Forventede årlige kilometer
    </div>
    <div class="w-56">
      <app-dropdown
        [errorInDropdown]="errorInSelectedAnnualMileage"
        [disableDropdown]="loadinginsuranceInfo"
        [selectedValue]="selectedAnnualMileage.name"
        [title]="'Kilometer'"
        [options]="dropdown_expectedAnnualMileage"
        (output)="dropdownOutput($event, 'annualMileage')"
      ></app-dropdown>
    </div>

    <div class="m-5" *ngIf="loadinginsuranceInfo && !annualMileagePriceUpdate">
      <lib-loading-indicator size="10"></lib-loading-indicator>
    </div>
  </div>

  <!-- If selectedAnnualMileage is selected -->
  <div
    *ngIf="selectedAnnualMileage.value !== -1 && annualMileagePriceUpdate"
    class="u-fade-in-step"
  >
    <div class="mb-6">
      <div class="flex mb-5">
        <div class="font-syne text-2xl font-semibold">
          Antal skader inden for de seneste 3 år
        </div>

        <span class="flex items-center">
          <div class="relative">
            <i
              (mouseover)="showTooltip_GlassCover = true"
              (mouseout)="showTooltip_GlassCover = false"
              class="fas fa-regular fa-circle-info text-gray-300 ml-4"
            ></i>
            <span
              class="text-sm z-10 bg-white border shadow-lg rounded-md absolute bottom-full left-1/2 transform -translate-x-1/2 px-6 py-4 w-96"
              [class.hidden]="!showTooltip_GlassCover"
            >
              <p class="font-medium mb-4">
                Hvor mange skader har du anmeldt på din ansvarsforsikring til
                din bil inden for de seneste 3 år?
              </p>
              <p class="mb-2 text-xs">
                Med skade menes enhver hændelse med din bil inden for de seneste
                3 år, hvor en tredjemand er blevet påført en skade som følge af
                din uagtsomhed.
              </p>
            </span>
          </div>
        </span>
      </div>

      <div class="w-56">
        <app-dropdown
          [errorInDropdown]="errorInSelectedNumberOfDamages"
          [selectedValue]="selectedNumberOfDamages.name"
          [disableDropdown]="loadinginsuranceInfo"
          [title]="'Antal skader'"
          [options]="dropdown_numberOfDamages"
          (output)="dropdownOutput($event, 'numberOfDamages')"
        ></app-dropdown>
      </div>
    </div>
    <!-- If selectedAnnualMileage is selected -->
    <div *ngIf="selectedNumberOfDamages.value !== -1" class="u-fade-in-step">
      <button
        *ngIf="!loadinginsuranceInfo"
        (click)="validateHelvetiaExtraInfo()"
        type="button"
        class="py-3 px-4 shadow-lg font-inter inline-flex items-center gap-x-1 text-sm rounded-full border border-transparent bg-teal-450 text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none"
      >
        Næste
      </button>
    </div>

    <div class="m-5" *ngIf="loadinginsuranceInfo">
      <lib-loading-indicator size="10"></lib-loading-indicator>
    </div>
  </div>
</div>
<!-- End Col -->

<div></div>
